import React from "react";
import { OverlayTrigger, Tooltip as BootstrapTooltip } from "react-bootstrap";

interface TooltipProps {
  content?: any;
  placement?: "top" | "bottom" | "left" | "right";
  children?: any;
  delay?: { show: number; hide: number };
}

export const Tooltip = ({
  content,
  placement = "top",
  children,
  delay = { show: 250, hide: 300 },
}: TooltipProps) => {
  // If there is no content, render children without attaching tooltip behavior.
  // This prevents empty tooltips or stray indicators from appearing.
  if (!content) {
    return <>{children}</>;
  }

  const renderTooltip = (props: any) => (
    <BootstrapTooltip id="tooltip" {...props} className="custom-tooltip">
      {content}
    </BootstrapTooltip>
  );

  return (
    <OverlayTrigger placement={placement} delay={delay} overlay={renderTooltip}>
      {children}
    </OverlayTrigger>
  );
};
